const responseType = {
  USE_PRESIGNED_URL_FOR_UPLOAD: 'USE_PRESIGNED_URL_FOR_UPLOAD',
  OBJECT_ALREADY_EXISTS: 'OBJECT_ALREADY_EXISTS',
};

export { responseType };
